import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import {
  DEFAULT_FINGER_NUMBERS_DISPLAY,
  type FingerNumbersDisplay,
} from 'Seeds/ExerciseContent/scaleFingering';
import { normalizeFingerNumbersDisplay } from './scaleFingerNumbersSettings';

export interface ScaleFingerNumbersState {
  display: FingerNumbersDisplay;
}

const initialState: ScaleFingerNumbersState = { display: DEFAULT_FINGER_NUMBERS_DISPLAY };

/**
 * The scale finger-number display setting in Redux. Kept like the key-signature display
 * setting: not redux-persisted, loaded from and saved to the signed-in user's namespaced
 * device storage by `useScaleFingerNumbersSync`.
 */
const scaleFingerNumbersSlice = createSlice({
  name: 'scaleFingerNumbers',
  initialState,
  reducers: {
    setScaleFingerNumbers(
      _state,
      action: PayloadAction<FingerNumbersDisplay>,
    ): ScaleFingerNumbersState {
      return { display: normalizeFingerNumbersDisplay(action.payload) };
    },
    scaleFingerNumbersHydrated(
      _state,
      action: PayloadAction<FingerNumbersDisplay>,
    ): ScaleFingerNumbersState {
      return { display: normalizeFingerNumbersDisplay(action.payload) };
    },
  },
});

export const { setScaleFingerNumbers, scaleFingerNumbersHydrated } =
  scaleFingerNumbersSlice.actions;

export const scaleFingerNumbersReducer = scaleFingerNumbersSlice.reducer;

// Falls back to the default for a store built without this slice (test stores).
export const selectScaleFingerNumbers = (state: {
  scaleFingerNumbersReducer?: ScaleFingerNumbersState;
}): FingerNumbersDisplay =>
  state.scaleFingerNumbersReducer?.display ?? DEFAULT_FINGER_NUMBERS_DISPLAY;
